/* eslint-disable import/no-cycle */
import styled from "styled-components";

import MessagingActionButton from "../../../../common/MessagingActionButton";

export const StyledMessagingButton = styled(MessagingActionButton)`
  margin-right: ${({ rightMarginValue }) => rightMarginValue}px;
`;
